import { cloneDeepWith, isArray } from 'lodash';

function echo(val: string) {
  return val;
}

function uppercaseFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getError(fieldName: string, errorObject: any, ...optionalConditions: []) {
  const areOptionalConditionsTrue = optionalConditions.every(item => item === true);

  return errorObject?.[fieldName] && areOptionalConditionsTrue
    ? (errorObject[fieldName] as string[]).reduce(
        (previous: string, current: string) =>
          `${uppercaseFirstLetter(previous)}${previous ? ',' : ''} ${uppercaseFirstLetter(current)}`,
        '',
      )
    : '';
}

interface ValidationErrors {
  [key: string]: string[] | ValidationErrors;
}

export function convertBaseErrors(validations: ValidationErrors): string {
  let error = '';

  cloneDeepWith(validations, (value: unknown) => {
    if (isArray(value)) {
      error = `${error}\n${(value as string[])[0]}`;
    }
  });

  return error;
}

// Join action handlers into a single reducer.
export function createReducer(initialState: any, handlers: any) {
  // eslint-disable-next-line @typescript-eslint/default-param-last
  return (state = initialState, action: { type: string | number }) => {
    return (handlers[action.type] || echo)(state, action);
  };
}
